import { combineReducers } from "@reduxjs/toolkit";
import { authApi } from "../features/auth/api/authApi";
import auth from "../features/auth/slices/authSlice";
import { chatApi } from "../features/chat/api/chatApi";
import { employeeApi } from "../features/employee/api/employeeApi";
import chat from "../features/chat/slices/chatSlice";
import { ApiCredentials } from "../features/apiCredentials/api/ApiCredentials";
import { companyApi } from "../features/company/api/companyApi";
import { businessHrsApi } from "../features/businessHour/api/businessHourApi";
import { scheduleMessageApi } from "../features/scheduleMessages/api/scheduleMessageApi";
import { bulkUploadApi } from "../features/bulkUpload/api/bulkUploadApi";

export const reducer = combineReducers({
    [auth.name]: auth.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [chat.name]: chat.reducer,
    [chatApi.reducerPath]: chatApi.reducer,
    [employeeApi.reducerPath]: employeeApi.reducer,
    [ApiCredentials.reducerPath]: ApiCredentials.reducer,
    [companyApi.reducerPath]: companyApi.reducer,
    [businessHrsApi.reducerPath]: businessHrsApi.reducer,
    [scheduleMessageApi.reducerPath]: scheduleMessageApi.reducer,
    [bulkUploadApi.reducerPath]: bulkUploadApi.reducer
})
